/** Five wildlife species. Letter map is used in fixtures and dev overlays. */

export type Wildlife = "bear" | "elk" | "salmon" | "hawk" | "fox";

export const WILDLIFE: readonly Wildlife[] = [
  "bear",
  "elk",
  "salmon",
  "hawk",
  "fox",
] as const;

export const WILDLIFE_LETTER: Readonly<Record<Wildlife, string>> = {
  bear: "B",
  elk: "E",
  salmon: "S",
  hawk: "H",
  fox: "X",
};
